/**
 * Global Imports
*/

import PropTypes from 'prop-types';
import React from 'react';

/**
 * Local Imports
*/

import { Input } from './Input';

/**
 * Exports
*/

/**
 * 
 */
export function Checkbox({ checked, ...props }) {
  return (
    <Input
      type='checkbox'
      elementProps={{ defaultChecked: checked }}
      beforeSetValue={ value => ( !value || value !== 'true' ).toString().replace('false', '') }
      { ...props }
    />
  );
}

Checkbox.propTypes = {
  name: PropTypes.string.isRequired,
  className: PropTypes.oneOfType([ PropTypes.string, PropTypes.array ]),
  checked: PropTypes.bool,
  label: PropTypes.string,
  onChange: PropTypes.func,
  formik: PropTypes.object
};

Checkbox.defaultProps = {
  checked: false
};